import { FluxUtilityType } from '@energy-retailer/constants';
import { z } from 'zod';

export const electricityConnectionSchema = z.object({
  utilityType: z.literal(FluxUtilityType.Electricity),
  externalId: z.string().optional(),
});

export const gasConnectionSchema = z.object({
  utilityType: z.literal(FluxUtilityType.Gas),
  externalId: z
    .string()
    .optional()
    .superRefine((value, ctx) => {
      const mirn = /^[a-zA-Z0-9]{10,11}$/.test(value as string);
      if (value?.length && !mirn) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'MIRN is not correct',
        });
        return false;
      }
      return true;
    }),
});

export type ElectricityConnectionSchema = z.infer<
  typeof electricityConnectionSchema
>;

export type GasConnectionSchema = z.infer<typeof gasConnectionSchema>;
